"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var firestore_1 = require("firebase/firestore");
var differenceBy_1 = __importDefault(require("lodash/differenceBy"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var MultiSelect_1 = __importDefault(require("atomicComponents/organisms/MultiSelect"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var hooks_1 = require("utils/hooks");
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var SimplifiedAutocomplete = (0, SimplifyFormInput_1.default)(MultiSelect_1.default);
var CompanyTeamSelect = function (_a) {
    var _b;
    var item = _a.item;
    var _c = __read(react_1.default.useState(false), 2), isChanging = _c[0], setIsChanging = _c[1];
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var companyTeams = (0, react_redux_1.useSelector)(ordered_1.selectCompanyTeams);
    var makeOptionFromTeam = function (team) { return ({ value: team.id, label: team.name }); };
    var _d = __read((0, hooks_1.useSubmitter)('service_stats', item.id), 1), updateServiceStat = _d[0];
    var _e = __read((0, hooks_1.useSubmitter)('company_teams', null, { companyId: company === null || company === void 0 ? void 0 : company.id }), 1), teamCreate = _e[0];
    var value = (_b = item.companyTeams) === null || _b === void 0 ? void 0 : _b.map(makeOptionFromTeam);
    var handleChange = function (newValue) { return __awaiter(void 0, void 0, void 0, function () {
        var newValuesWithIdx, toAdd, newIds, toRemove;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsChanging(true);
                    newValuesWithIdx = newValue.map(function (v, idx) { return (__assign(__assign({}, v), { idx: idx })); });
                    toAdd = (0, differenceBy_1.default)(newValuesWithIdx, value || [], 'value');
                    if (!(toAdd === null || toAdd === void 0 ? void 0 : toAdd.length)) return [3 /*break*/, 3];
                    return [4 /*yield*/, Promise.all(newValuesWithIdx.map(function (opt) { return __awaiter(void 0, void 0, void 0, function () {
                            var newTeamRef;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!opt.isNew)
                                            return [2 /*return*/, opt.value];
                                        return [4 /*yield*/, teamCreate({ name: opt.label, serviceStatIds: [item.id], headcount: 1 })];
                                    case 1:
                                        newTeamRef = _a.sent();
                                        newValuesWithIdx[opt.idx] = { value: newTeamRef.id, label: opt.label, idx: opt.idx };
                                        return [2 /*return*/, newTeamRef.id];
                                }
                            });
                        }); }))];
                case 1:
                    newIds = _a.sent();
                    return [4 /*yield*/, updateServiceStat({ companyTeamIds: firestore_1.arrayUnion.apply(void 0, __spreadArray([], __read(newIds), false)) })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    toRemove = (0, differenceBy_1.default)(value || [], newValue, 'value');
                    if (!(toRemove === null || toRemove === void 0 ? void 0 : toRemove.length)) return [3 /*break*/, 5];
                    return [4 /*yield*/, updateServiceStat({ companyTeamIds: firestore_1.arrayRemove.apply(void 0, __spreadArray([], __read(toRemove.map(function (t) { return t.value; })), false)) })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    setIsChanging(false);
                    return [2 /*return*/, newValuesWithIdx];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(SimplifiedAutocomplete, { isDisabled: isChanging, label: "Add a Team", 
        // options={companyTeams?.map(makeOptionFromTeam).filter((cT) => !value?.find((v) => v.value === cT.value))}
        options: companyTeams === null || companyTeams === void 0 ? void 0 : companyTeams.map(makeOptionFromTeam), onBlur: handleChange, value: value || [], placeholder: "Select a team or create one" }));
};
exports.default = react_1.default.memo(CompanyTeamSelect);
